import { TableCell, Tooltip } from '@material-ui/core';
import React from 'react';
export const VirtualDefaultCell = props => {
  var _props$cellData$toStr, _props$cellData, _props$cellData2;

  return /*#__PURE__*/React.createElement(TableCell, {
    style: {
      height: '57px',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'left',
      padding: 0,
      paddingRight: 20
    },
    component: "div"
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: (_props$cellData$toStr = (_props$cellData = props.cellData) === null || _props$cellData === void 0 ? void 0 : _props$cellData.toString()) !== null && _props$cellData$toStr !== void 0 ? _props$cellData$toStr : '',
    placement: "top"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    }
  }, (_props$cellData2 = props.cellData) === null || _props$cellData2 === void 0 ? void 0 : _props$cellData2.toString())));
};
//# sourceMappingURL=VirtualDefaultCell.js.map